/* eslint-disable import/no-anonymous-default-export */
export default {
    baseurl: `https://emore.pythonanywhere.com/`,
    baseurlAuth: `https://emore.pythonanywhere.com/Auth/`,
  };
  